import React from 'react'
import { useTranslation } from 'react-i18next'

import './title.sass'

interface Props {
    text: string
    secondary?: boolean
    h2h?: boolean
}

const Title = ({ text, secondary, h2h = false }: Props) => {
    const [t] = useTranslation()
    return (
        <>
            {!h2h ? (
                <header>
                    <h1 className={secondary ? 'secondary' : 'primary'}>{t(text)}</h1>
                </header>
            ) : (
                <h2 className={secondary ? 'secondary' : 'primary'}>{t(text)}</h2>
            )}
        </>
    )
}

export default Title
